import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute"; // Import the private route component
import PublicRoute from "./PublicRoute";
// Public pages
import Login from "../pages/Login/Login";
import PageNotFound from "../pages/PageNotFound/PageNotFound";

// Protected pages
import AnalyticsDash from "../pages/AnalyticsDashboard/AnalyticsDash";
import Analytics from "../pages/AnalyticsDashboard/Analytics";
import FDReporting from "../pages/Reports/FDReports";
import UserDetails from "../pages/UserDetails/UserDetails";
import NomineeDetails from "../pages/NomineeDetails/NomineeDetails";
import DematDetails from "../pages/DematDetails/DematDetails";
import FDRequest from "../pages/Requests/FD/FDRequest";
import AgentMaster from "../pages/AgentMaster/AgentMaster";
import UserEdit from "../pages/UserDetails/UserEdit";
import AddUser from "../pages/AddUser/AddUser";
import MFTransactions from "../pages/Reports/MFTransactions";
import Requests from "../pages/AllRequests/Requests";
import AllOrders from "../pages/Requests/AllOrders";
import AIF from "../pages/Upload/AIF";
import PMS from "../pages/Upload/PMS";
import Bonds from "../pages/Upload/Bonds";
import RMDetails from "../pages/RelationManager/RMDetails";
import AddRM from "../pages/AddRM/AddRM";
import AssignRM from "../pages/RelationManager/AssignRM";
import AIFReports from "../pages/Reports/AIFBuyReports";
import MFReports from "../pages/Reports/MFReports";
import PMSReports from "../pages/Reports/PMSBuyReports";
import BondsReports from "../pages/Reports/BondsReports";
import Holdings from "../pages/Holdings/Holdings";
import Preferences from "../pages/Holdings/Preferences";
import UploadComponent from "../pages/Holdings/Upload";
import AifHolding from "../pages/Holdings/AifHoldings";
import PmsHoldings from "../pages/Holdings/PmsHoldings";
import AIFSellReports from "../pages/Reports/AIFSellReports";
import PMSSellReports from "../pages/Reports/PMSSellReports";
import UploadHoldings from "../pages/Holdings/UploadHoldings";
import UploadPreferences from "../pages/Holdings/UploadPreferences";
import Profile from "../pages/Profile Page/Profile";
import FDHoldings from "../pages/Holdings/FDHoldings";
import MFHoldings from "../pages/Holdings/MFHoldings";
import FDReportingSell from "../pages/Reports/FDReportsSell";
import Append from "../pages/Holdings/Append";
import Replace from "../pages/Holdings/Replace";
import BONDHoldings from "../pages/Holdings/BONDHoldings";
import STOCKHoldings from "../pages/Holdings/STOCKHoldings";
import UnlistedBuyReports from "../pages/Reports/UnlistedBuyReports";
import UnlistedSellReports from "../pages/Reports/UnlistedSellReports";
import UnlistedHoldings from "../pages/Holdings/UnlistedHoldings";
import Pricing from "../pages/Pricings/Pricings";
import PartnerDetails from "../pages/Partners/RMDetails";
import AddPartner from "../pages/AddPartner/AddPartner";
import Dashboard from "../pages/Dashboard/Dashboard";
import InvestorReport from "../pages/CustomerReports/InvestorReport";
import InvestmentReport from "../pages/CustomerReports/InvestmentReport";
import AppLayout from "../layouts/AppLayout";
import MFListing from "../pages/AssetListing/MFListing";
import AIFListing from "../pages/AssetListing/AIFListing";
import PMSListing from "../pages/AssetListing/PMSListing";
import FDListing from "../pages/AssetListing/FDListing";
import PrivateStockListing from "../pages/AssetListing/PrivateStockListing";
import BondListing from "../pages/AssetListing/BondListing";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import UnlistedInventory from "../pages/Unlisted/UnlistedInventory";
import RMUnlistedInventory from "../pages/Unlisted/rm/RMUnlistedInventory";
import UnlistedOrders from "../pages/Unlisted/UnlistedOrders";
import UnlistedInvestors from "../pages/Unlisted/UnlistedInvestors";
import TransactionReport from "../pages/Unlisted/TransactionReport";
import TransactionReportAdmin from "../pages/Unlisted/TransactionReportAdmin";
import TransactionReportStatus from "../pages/Unlisted/TransactionReportStatus";
import TransactionReportPending from "../pages/Unlisted/TransactionReportPending";
import UnlistedDPMapping from "../pages/Unlisted/UnlistedDPMapping";
import MisReport from "../pages/Unlisted/MisReport";
import InventoryReconciliation from "../pages/Unlisted/InventoryReconciliation";
import StockReconciliation from "../pages/Unlisted/StockReconciliation";
import SuperAdminRoute from "./SuperAdminRoute";
import SuperAdminDashboard from "../pages/SuperAdminDashboard/SuperAdminDashboard";
import DailyUsers from "../pages/SuperAdminDashboard/DailyUsers";
import DailyAUT from "../pages/SuperAdminDashboard/DailyAUT";
import TransactionsInitiated from "../pages/SuperAdminDashboard/TransactionsInitiated";
import KYCInitiated from "../pages/SuperAdminDashboard/KYCInitiated";
import FamilyData from "../pages/SuperAdminDashboard/FamilyData";
import UserLogins from "../pages/SuperAdminDashboard/UserLogins";
import BestWorstHoldings from "../pages/SuperAdminDashboard/BestWorstHoldings";
import Curations from "../pages/Curations/Curations";
import MarketPicks from "../pages/Curations/MarketPicks";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route element={<PublicRoute />}>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
        <Route path="/" element={<AppLayout />}>
          {/* Public Routes */}
          {/* Protected Routes (wrapped inside PrivateRoute) */}
          <Route element={<PrivateRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/analytics" element={<AnalyticsDash />} />
            <Route path="/payout-analytics" element={<Analytics />} />
            <Route path="/requests" element={<Requests />} />
            <Route path="/requests/all-orders" element={<AllOrders />} />
            <Route path="/reports/fd/buy" element={<FDReporting />} />
            <Route path="/reports/fd/sell" element={<FDReportingSell />} />
            <Route path="/investor" element={<UserDetails />} />
            <Route path="/investor/demat" element={<DematDetails />} />
            <Route path="/investor/nominee" element={<NomineeDetails />} />
            <Route path="/requests/fd" element={<FDRequest />} />
            <Route path="/userDetails/:id" element={<UserEdit />} />
            <Route path="/addDetails" element={<AddUser />} />
            <Route path="/investor/agent" element={<AgentMaster />} />
            <Route
              path="/reports/mf/transactions"
              element={<MFTransactions />}
            />
            <Route path="/upload/file-aif" element={<AIF />} />
            <Route path="/upload/file-pms" element={<PMS />} />
            <Route path="/upload/file-bonds" element={<Bonds />} />
            <Route path="/rm" element={<RMDetails />} />
            <Route path="/partners" element={<PartnerDetails />} />
            <Route path="/addRM" element={<AddRM />} />
            <Route path="/addPartner" element={<AddPartner />} />
            <Route path="/assign-rm" element={<AssignRM />} />
            <Route path="/aif/buy" element={<AIFReports />} />
            <Route path="/aif/sell" element={<AIFSellReports />} />
            <Route path="/private-stock/buy" element={<UnlistedBuyReports />} />
            <Route
              path="/private-stock/sell"
              element={<UnlistedSellReports />}
            />
            <Route path="/pms/buy" element={<PMSReports />} />
            <Route path="/pms/sell" element={<PMSSellReports />} />
            <Route path="/bonds" element={<BondsReports />} />
            <Route path="/holdings" element={<Holdings />} />
            <Route path="/uploadHoldings" element={<UploadHoldings />} />
            <Route path="/preferences" element={<Preferences />} />
            <Route path="/upload/preferences" element={<UploadPreferences />} />
            <Route path="/upload/preference/append/:id" element={<Append />} />
            <Route
              path="/upload/preference/replace/:id"
              element={<Replace />}
            />
            <Route
              path="/preference/corporateFD/:id"
              element={<FDHoldings />}
            />
            <Route
              path="/preference/mutualFunds/:id"
              element={<MFHoldings />}
            />
            <Route path="/preference/bonds/:id" element={<BONDHoldings />} />
            <Route path="/preference/equity/:id" element={<STOCKHoldings />} />
            <Route
              path="/preference/privateStock/:id"
              element={<UnlistedHoldings />}
            />
            <Route path="/preference/aif/:id" element={<AifHolding />} />
            <Route path="/preference/pms/:id" element={<PmsHoldings />} />
            <Route path="/upload" element={<UploadComponent />} />
            <Route path="/reports/mf" element={<MFReports />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/payout" element={<Pricing />} />
            <Route path="/investor/reports" element={<InvestorReport />} />
            <Route path="/investment/reports" element={<InvestmentReport />} />
            <Route path="/listing/mf" element={<MFListing />} />
            <Route path="/listing/aif" element={<AIFListing />} />
            <Route path="/listing/pms" element={<PMSListing />} />
            <Route path="/listing/fd" element={<FDListing />} />
            <Route
              path="/listing/private-stock"
              element={<PrivateStockListing />}
            />
            <Route path="/listing/bonds" element={<BondListing />} />
            <Route path="/unlisted/inventory" element={<UnlistedInventory />} />
            <Route
              path="/rm/unlisted/inventory"
              element={<RMUnlistedInventory />}
            />
            <Route path="/rm/unlisted/orders" element={<UnlistedOrders />} />
            <Route path="/admin/unlisted/orders" element={<UnlistedOrders />} />
            <Route path="/unlisted/investors" element={<UnlistedInvestors />} />
            <Route path="/unlisted/holdings" element={<TransactionReport />} />
            <Route path="/unlisted/admin-holdings" element={<TransactionReportAdmin />} />
            <Route path="/unlisted/holdings-status" element={<TransactionReportStatus />} />
            <Route path="/unlisted/holdings-pending" element={<TransactionReportPending />} />
            <Route path="/unlisted/mis-report" element={<MisReport />} />
            <Route path="/unlisted/dpmaping" element={<UnlistedDPMapping />} />
            <Route path="/unlisted/reconciliation" element={<InventoryReconciliation />} />
            <Route path="/unlisted/stock-reconciliation" element={<StockReconciliation />} />
            <Route path="/curations" element={<Curations />} />
            <Route path="/curations/market-picks" element={<MarketPicks />} />
            <Route element={<SuperAdminRoute />}>
              <Route path="/super-admin/ops-dashboard" element={<SuperAdminDashboard />} />
              <Route path="/super-admin/ops/daily-users" element={<DailyUsers />} />
              <Route path="/super-admin/ops/aut" element={<DailyAUT />} />
              <Route path="/super-admin/ops/transactions-initiated" element={<TransactionsInitiated />} />
              <Route path="/super-admin/ops/kyc-initiated" element={<KYCInitiated />} />
              <Route path="/super-admin/ops/family-data" element={<FamilyData />} />
              <Route path="/super-admin/ops/user-logins" element={<UserLogins />} />
              <Route path="/super-admin/ops/best-worst-holdings" element={<BestWorstHoldings />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
